// src/stone/illustrations/MachinePosIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MachinePosIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 37",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M27.302 10.157c-1.2 1.597-3.726 3.892-4.747 5.456l-1.747 3.034v.001l-7.145 12.408c-.527.805-1.597 1.165-2.392.803l-4.778-2.178 4.3-9.157L19.5 1.99l6.614 3.015c1.936.883 2.47 3.19 1.19 5.152"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m15.897 18.523 1.442 6.149-3.676 6.384c-.527.805-1.597 1.165-2.392.802L6.494 29.68z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M10.863 29.484 22.88 3.531 15.754.283C13.99-.521 11.6.456 10.716 2.345L.155 25.197c-.351.759-.088 1.554.62 1.877l7.566 3.448c.885.405 2.083-.09 2.522-1.038"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m21.7 2.993 4.559 2.078c-1.764-.804-4.153.173-5.038 2.062l-.55-2.563z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m10.097 28.602 1.848-4.087c.162-.35.018-.727-.338-.89l-7.046-3.211c-.44-.201-1.016.008-1.216.44L1.497 24.94c-.162.35-.018.727.338.89l7.046 3.212c.44.2 1.016-.008 1.216-.44M18.157 11.036a.1.1 0 0 1-.037-.009L9.615 7.151a.09.09 0 0 1-.045-.119.09.09 0 0 1 .12-.044l8.504 3.877a.09.09 0 0 1 .045.118.09.09 0 0 1-.082.053"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m9.084 29.073-7.352-3.35a.655.655 0 0 1-.325-.872l1.963-4.256a.663.663 0 0 1 .877-.324l7.351 3.35a.656.656 0 0 1 .326.872L9.96 28.75a.66.66 0 0 1-.876.323M11.924 22.92l-7.35-3.35a.656.656 0 0 1-.326-.872l4.674-10.13a.663.663 0 0 1 .877-.324l7.351 3.35a.656.656 0 0 1 .326.872l-4.674 10.13a.663.663 0 0 1-.878.325"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m19.363 8.897 1.404-2.757c.32-.627-.005-1.365-.747-1.704l-6.085-2.773c-.848-.387-1.895-.103-2.26.612"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M19.363 8.985a.089.089 0 0 1-.08-.13L20.686 6.1c.13-.256.149-.534.053-.806-.116-.33-.386-.607-.758-.777l-6.085-2.773c-.8-.365-1.8-.098-2.142.571a.09.09 0 0 1-.12.04.09.09 0 0 1-.04-.12c.389-.764 1.477-1.063 2.376-.653l6.086 2.774c.417.19.72.503.853.88.11.314.088.649-.063.945l-1.404 2.756a.09.09 0 0 1-.08.049"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m8.678 24.268.862-1.867-.163-.074-.862 1.867-2.688-1.225.861-1.867-.163-.075-.86 1.868-2.956-1.347-.075.161 2.955 1.347-.863 1.872-2.955-1.347-.075.162 2.955 1.347-.917 1.988.163.074.917-1.988 2.689 1.225-.918 1.989.163.074 1.856-4.022 2.966 1.353.075-.163zm-1.1 1.96-2.69-1.226.864-1.871 2.689 1.225z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M17.633 24.251a.09.09 0 0 1-.089-.075l-.95-5.746a.09.09 0 0 1 .074-.103.09.09 0 0 1 .103.074l.95 5.747a.09.09 0 0 1-.088.103"
        }
      ),
      /* @__PURE__ */ jsx("g", { filter: "url(#machine-pos_Illustration_svg__a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E8E9EA",
          d: "M24 31.807c4.418 0 8-3.56 8-7.952s-3.582-7.952-8-7.952-8 3.56-8 7.952 3.582 7.952 8 7.952"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m29.126 20.563-.487 2.248a.67.67 0 0 1-.796.513l-2.264-.478a.668.668 0 1 1 .279-1.306l.858.181a3.48 3.48 0 0 0-3.73-1.155c-.85.259-1.56.825-1.997 1.593a.674.674 0 0 1-.915.253.666.666 0 0 1-.254-.91 4.78 4.78 0 0 1 2.771-2.213 4.83 4.83 0 0 1 5.108 1.517l.113-.524a.67.67 0 0 1 .798-.513.667.667 0 0 1 .516.794M28.181 26.209a4.78 4.78 0 0 1-2.771 2.212 4.84 4.84 0 0 1-5.107-1.516l-.114.524a.671.671 0 0 1-1.314-.281l.488-2.248a.67.67 0 0 1 .796-.513l2.264.477a.667.667 0 1 1-.28 1.306l-.858-.18a3.48 3.48 0 0 0 3.73 1.155 3.45 3.45 0 0 0 1.997-1.594.673.673 0 0 1 .916-.251.664.664 0 0 1 .253.909"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "filter",
        {
          id: "machine-pos_Illustration_svg__a",
          width: 22,
          height: 21.903,
          x: 13,
          y: 14.903,
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
            /* @__PURE__ */ jsx(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
            /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 1.5 }),
            /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0 0.333333 0 0 0 0.32 0" }),
            /* @__PURE__ */ jsx(
              "feBlend",
              {
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_5041_21035"
              }
            ),
            /* @__PURE__ */ jsx(
              "feBlend",
              {
                in: "SourceGraphic",
                in2: "effect1_dropShadow_5041_21035",
                result: "shape"
              }
            )
          ]
        }
      ) })
    ]
  }
);
var MachinePosIllustration_default = MachinePosIllustration;

export {
  MachinePosIllustration,
  MachinePosIllustration_default
};
